import logo from '../../assets/images/logo.svg'
import { TermsModal } from '../../components/molecules'
import pdf from '../../assets/documents/terms-of-use.pdf'
import { ReactElement, useCallback, useEffect } from 'react'
import { updateUserProfile } from '../../libs/services'
import { useAuth } from '../../hooks/useAuth'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const Terms = (): ReactElement => {
  const { userProfile, setUserProfile } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (userProfile === null || userProfile === undefined) {
      navigate('/')
    } else if (userProfile?.user_profile?.accepted_terms) {
      if (userProfile?.role?.slug === 'admin') {
        navigate('/dashboard/all-assigned-students')
      } else {
        navigate('/user-dashboard')
      }
    }
  }, [userProfile, navigate])

  const handleAcceptTerms = useCallback((setIsSubmitting: React.Dispatch<boolean>) => {
    setIsSubmitting(true)
    updateUserProfile({ accepted_terms: true })
      .then((res) => {
        if (res !== null || res !== undefined) {
          const updatedProfile = res?.data?.data
          setUserProfile({ ...userProfile, user_profile: updatedProfile })
          if (userProfile?.role.slug === 'admin') {
            navigate('/dashboard/all-assigned-students')
          } else {
            navigate('/user-dashboard')
          }
        } else {
          toast.error('Unable to update user profile', {
            position: toast.POSITION.TOP_CENTER
          })
        }
        setIsSubmitting(false)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_CENTER
        })
        setIsSubmitting(false)
      })
  }, [navigate, setUserProfile, userProfile])
  return (
    <div className='bg-black min-h-screen font-primary items-center flex justify-center'>
      <h1 className='sr-only'>Privacy and Terms of Use Agreement</h1>
      <header className='absolute left-[40px] top-[40px]' aria-hidden='true'>
        <img src={logo} className='w-[138px]' alt='logo' />
      </header>

      <section className='flex justify-center'>
        <TermsModal pdfUrl={pdf} handleAcceptTerms={handleAcceptTerms} />
      </section>
    </div>
  )
}

export default Terms
